<ng-container [ngSwitch]="data">
  <div *ngIf="data == '1'" i18n="@@common.revenue_per_action">Revenue per action (RPA)</div>
</ng-container>
